'use strict';
import classNames from 'classnames';
import isNumber from 'lodash/isNumber';
import React from 'react';
import {I18nMessage} from '../../../../../components/I18nMessage';
import {responseFieldViewpropTypes} from '../utils';


export function ScaleFieldViewView(props) {
  const value = getScaleValue(props.value);
  return (
    <p className={classNames("ScaleFieldView", props.className)}>
      {value ? value : (
        <i>
          <I18nMessage message="forms.response.default.placeholder" />
        </i>
      )}
    </p>
  );
}

export function getScaleValue(result) {
  if (!result) {
    return null;
  } else if (isNumber(result.high)) {
    return `${result.value}\u2026${result.high}`;
  } else {
    return result.value;
  }
}

ScaleFieldViewView.propTypes = responseFieldViewpropTypes;



// WEBPACK FOOTER //
// ./src/js/form-builder/components/response/fields/ScaleFieldView/ScaleFieldViewView.js